module.exports = __webpack_public_path__ + "img/forklifts.89d7a724.webp";